import { render, staticRenderFns } from "./BestBetForm.vue?vue&type=template&id=0dd63b87"
import script from "./BestBetForm.vue?vue&type=script&lang=js"
export * from "./BestBetForm.vue?vue&type=script&lang=js"
import style0 from "./BestBetForm.vue?vue&type=style&index=0&id=0dd63b87&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports